import React from 'react'
export const LicenceNumContext = React.createContext()